import {
  GuideTargetHistoryDto,
  GuideTargetRowDto,
  GuideTargetsAvailablePeriodsDto,
  PaginatedGuideTargetsDto,
  UpdateGuideTargetsRequestDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const guideTargetsRequests = {
  getGuideTargetsAvailablePeriods: EndpointDefinition.get<
    GuideTargetsAvailablePeriodsDto,
    null
  >({
    name: 'getGuideTargetsAvailablePeriods',
    route: '/guides/guide-targets/available-periods',
  }),
  getGuideTargets: EndpointDefinition.get<
    PaginatedGuideTargetsDto,
    {
      yearMo: number;
      'page-start': number;
      'page-size': number;
      'sort-by'?: string;
      'sort-direction'?: string;
      clientIds?: number[];
      guideIds?: string[];
      targetTypeKeys?: string[];
      serviceAreaKeys?: string[];
    }
  >({
    name: 'getGuideTargets',
    route: '/guides/guide-targets',
  }),
  updateGuideTargets: EndpointDefinition.patch<
    { targets: GuideTargetRowDto[]; history: GuideTargetHistoryDto[] },
    UpdateGuideTargetsRequestDto,
    null
  >({
    name: 'updateGuideTarget',
    route: '/guides/guide-targets',
  }),
  getGuideTargetHistory: EndpointDefinition.get<
    GuideTargetHistoryDto[],
    { id: number }
  >({
    name: 'getGuideTargetHistory',
    route: '/guides/guide-targets/:id/history',
  }),
};
